import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StudyList, StyledExplorerList } from './styled/StyledExplorer';
import { addStudy, setMainStudyId } from '../../../actions/PatientActions';
import { SeriesExplorer } from './SeriesExplorer';
import StudyItem from './StudyItem';
import { getStudyById } from '../../../util/studiesManager';
import { selectSeries } from '../Viewer/Layout/LayoutUtils';

export const StudiesExplorer = ({ currentTab, setCurrentTab, tabOptions }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);

  const config = useSelector((state) => state.config);
  const patient = useSelector((state) => state.patient);
  const layout = useSelector((state) => state.layout);

  const { LOADS_FIRST_SERIES_ON_HISTORY_CLICK, FETCH_SERIES_BY_ACCESSION_NUMBER } = config;

  const { mainStudyId, patientHistory, studies } = patient;
  const [selected] = useState(0);
  const [orderedStudies, setOrderedStudies] = useState([]);

  const checkFold = (studyId) => {
    if (currentTab === tabOptions.HISTORY_TAB) {
      if (!isOpen) {
        LOADS_FIRST_SERIES_ON_HISTORY_CLICK && setCurrentTab(tabOptions.STUDY_TAB);
      }
      setIsOpen(false);
    }
    if (mainStudyId) {
      if (studyId !== mainStudyId) {
        setIsOpen(true);
        return;
      }
      if (studyId === mainStudyId && !isOpen) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    }
  };

  const changeStudy = async (studyLight) => {
    const { StudyInstanceUID, AccessionNumber, servers } = studyLight;
    if (FETCH_SERIES_BY_ACCESSION_NUMBER) {
      servers.forEach((server, index) => {
        servers[index].seriesExtraFilters = { AccessionNumber };
      });
    }
    const swapStudy = await getStudyById(StudyInstanceUID, servers);
    dispatch(setMainStudyId(swapStudy.StudyInstanceUID));
    dispatch(addStudy(swapStudy)); // adds new study data to patient.studies store object
    if (LOADS_FIRST_SERIES_ON_HISTORY_CLICK) {
      const series = swapStudy.series[0];
      selectSeries(swapStudy, series, layout.selectedViewIndex);
    }
    checkFold(swapStudy.StudyInstanceUID);
  };

  useEffect(() => {
    if (currentTab === tabOptions.HISTORY_TAB && config.WITH_PATIENT_HISTORY && patientHistory) {
      let orderedStudies = patientHistory.sort((a, b) => b.StudyDate - a.StudyDate);

      if (orderedStudies.length) {
        setOrderedStudies(orderedStudies);
      }
    } else {
      const currentStudy = studies.filter((study) => study.StudyInstanceUID === mainStudyId)[0] || studies[0];
      setOrderedStudies([currentStudy]);
      setIsOpen(true);
    }
  }, [patientHistory, currentTab, mainStudyId]);

  return (
    <StyledExplorerList>
      {orderedStudies.map((studyLight, i) => (
        <StudyList key={`${studyLight.StudyInstanceUID}-${i.toString()}`} selected={selected === i}>
          <StudyItem
            study={studyLight}
            selected={selected === i}
            onClick={() => {
              if (!isOpen) {
                changeStudy(studyLight, i).then();
              } else if (mainStudyId !== studyLight.StudyInstanceUID) {
                changeStudy(studyLight, i).then();
              } else {
                checkFold(studyLight.StudyInstanceUID);
              }
            }}
            key={`StudyItem-${i.toString()}`}
          />
          {mainStudyId && studyLight.StudyInstanceUID === mainStudyId && isOpen ? <SeriesExplorer /> : null}
        </StudyList>
      ))}
    </StyledExplorerList>
  );
};
